/**
 * Backend HTTP trigger URLs.
 * - Local: Gatsby proxies `/api/*` → sharpen functions-framework (leave unset).
 * - Production: set `GATSBY_API_SHARPEN_URL` and `GATSBY_API_PAYMENTS_URL` on Vercel (see DEPLOY.md).
 * If `GATSBY_API_PAYMENTS_URL` is unset but `GATSBY_API_SHARPEN_URL` is set, payments URL is derived by
 * replacing the path segment `sharpen-image` with `photosharpener-payments`.
 */
export function sharpenApiUrl(): string {
  const direct = process.env.GATSBY_API_SHARPEN_URL || "https://europe-west1-photosharpener.cloudfunctions.net/sharpen-image"
  return direct.replace(/\/$/, "")
}

export function paymentsApiUrl(): string {
  const direct = process.env.GATSBY_API_PAYMENTS_URL || "https://europe-west1-photosharpener.cloudfunctions.net/photosharpener-payments"
  return direct.replace(/\/$/, "")
}
